import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useContext, watch } from "@nuxtjs/composition-api";
import { AUTH_FLOW_STEPS } from "~/core/services/utils/Constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFASwitcher',
  setup(__props) {

const { store } = useContext();
const user = computed(() => store.getters['application/driver/authUser']);
const user2FaStatus = computed(() => user.value?.is2FAEnabled || false);
const switcherState = ref(user2FaStatus.value);

const openTwoFactorFlow = async () => {
    await store.dispatch('application/driver/setAuthStep', AUTH_FLOW_STEPS.TWO_FACTOR_CODE);
    await store.dispatch('application/popup-control/changeConnectWalletPopupStatus', true);
};

let openingTimeout = null;
const handleToggle = () => {
    if (switcherState.value === user2FaStatus.value) {
        openingTimeout = setTimeout(async () => {
            await openTwoFactorFlow();
            switcherState.value = user2FaStatus.value;
            openingTimeout = null;
        }, 350);
    } else {
        clearTimeout(openingTimeout);
        openingTimeout = null;
    }

    switcherState.value = !switcherState.value;
};

watch(user2FaStatus, () => {
    switcherState.value = user2FaStatus.value;
}, { immediate: true });

return { __sfc: true,store, user, user2FaStatus, switcherState, openTwoFactorFlow, openingTimeout, handleToggle }
}

})